import { createSelector } from 'reselect';

import { RootState } from '../reducers';

export const getCurrentFullLocation = (state: RootState): string =>
  state.router.location ? state.router.location.pathname : '';
export const getQueryStrings = (state: RootState): string => state.router.location.search;

export const getCurrentLastPathLocation = (state: RootState): string => {
  const location = state.router.location ? state.router.location.pathname : '';
  return location.substr(location.lastIndexOf('/') + 1, location.length);
};

export const getLocationIsInPath = (state: RootState, location: string): boolean => {
  const fullPath = state.router.location ? state.router.location.pathname : '';
  return fullPath.indexOf(location) > 0;
};

export const getUrlParams = createSelector(
  [getQueryStrings],
  (queryStringParams: string): { [key: string]: string } | undefined => {
    if (queryStringParams.length === 0) {
      return undefined;
    }
    const paramsToArray = queryStringParams.substr(1, queryStringParams.length).split('&');
    const paramsObj = {};
    paramsToArray.forEach((query) => {
      const splittedQuery = query.split('=');
      paramsObj[splittedQuery[0]] = splittedQuery[1];
    });
    return paramsObj;
  },
);

/**
 * TODO rework
 * Check if an array of locations is in the current path and returns the location matched
 * @param {RootState} state
 * @param {string | string[]} location
 * @returns {string | undefined}
 */
export const getLocationFromPath = createSelector(
  [getCurrentFullLocation],
  (fullPath: string) =>
    (location: string[]): string | undefined => {
      let locationFound;

      (location as string[]).forEach((loc) => {
        const locationIndexInPath = fullPath.indexOf(loc);
        if (locationIndexInPath > 0) {
          locationFound = fullPath.substr(locationIndexInPath, loc.length);
        }
      });

      return locationFound;
    },
);
